import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class VotacionService 
{
    constructor(private http: HttpClient) { }

 
    obtieneVotacion(id: any) 
    { 
        return this.http.get(`${environment.urlBase}/votacionPregunta/${id}`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }

    existeVotacionUsuario(id: any) 
    { 
        return this.http.get(`${environment.urlBase}/existeVotacionUsuario/${id}`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }


    enviarVotacion(idUsuario: any,lugarTrabajo: any,direccionRegional: any,candidato: any) {

        return this.http.post(`${environment.urlBase}/guardarVotacionPregunta`,
            {
                idUsuario: idUsuario,
                lugarTrabajo: lugarTrabajo,
                direccionRegional: direccionRegional,
                candidato: candidato        

            },
            { headers: this.armaCabecera() }).toPromise();
    }

    obtieneProductosPorId(idProducto: any) 
    { 
        return this.http.get(`${environment.urlBase}/productosPorId/${idProducto}`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }
   

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}